import PropTypes from 'prop-types'
import React from "react"
import { Modal, ModalBody } from "reactstrap"

const DeleteModal = ({ show, onDeleteClick, onCloseClick }) => {
  return (
    <Modal size="md" isOpen={show} toggle={onCloseClick} centered={true}>
        <ModalBody className="px-4 py-5 text-center">
          {/* CORRECTION CI-DESSOUS : onClick={onCloseClick} au lieu de onDeleteClick */}
          <button 
            type="button" 
            onClick={onCloseClick} 
            className="btn-close position-absolute end-0 top-0 m-3"
          ></button>
          
          <div className="avatar-sm mb-4 mx-auto">
            <div className="avatar-title bg-primary text-primary bg-opacity-10 font-size-20 rounded-3">
              <i className="mdi mdi-trash-can-outline"></i>
            </div>
          </div>
          <p className="text-muted font-size-16 mb-4">
            Etes-vous sûr de vouloir effacer définitivement cet enregistrement ?
          </p>

          <div className="hstack gap-2 justify-content-center mb-0">
            <button type="button" className="btn btn-danger" onClick={onDeleteClick}>
                Supprimer
            </button>
            <button type="button" className="btn btn-secondary" onClick={onCloseClick}>
                Fermer
            </button>
          </div>
        </ModalBody>
    </Modal>
  )
}

DeleteModal.propTypes = {
  onCloseClick: PropTypes.func,
  onDeleteClick: PropTypes.func,
  show: PropTypes.any
}

export default DeleteModal